import React, {Fragment} from "react"
import { Link } from "react-router-dom"


const CategoryWidget = [
    {
        category: "Diseño UX/UI",
        number:"26",
        routerPath: "blog-details",
    },
    {
        category: "Asistente de Enfermería",
        number:"30",
        routerPath: "blog-details",
        
    },
    {
        category: "Diseñador Web",
        number:"",
        routerPath: "71",
    },
    {
        category: "Asistente Médico",
        number:"56",
        routerPath: "blog-details",
    },
    {
        category: "Coordinador de Marketing",
        number:"60",
        routerPath: "blog-details",
    },
]

const CategoryWidgetTwo = () => {
    return (
        <Fragment>
            <ul className="list-none">
                {CategoryWidget.map((val,i)=>(
                    <li key={i}>
                        <Link href="#">{val.category} <span className="f-right">{val.number}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </Fragment>
    )
}

export default CategoryWidgetTwo